import { collection, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from '../firebase';

// In-memory live cache of admin-set pokemon defaults, keyed by format + name.
// Populated via onSnapshot subscriptions booted from index.js.
const cache = { singles: {}, doubles: {} };
const listeners = new Set();

let initialized = false;

export function initOverridesSubscription() {
  if (initialized) return;
  initialized = true;

  const subscribe = (format) => {
    const col = collection(db, `pokemon_defaults_${format}`);
    onSnapshot(
      col,
      (snap) => {
        const next = {};
        snap.forEach((d) => { next[d.id] = d.data(); });
        cache[format] = next;
        listeners.forEach((fn) => { try { fn(); } catch {} });
      },
      (err) => {
        // Public read rule means this shouldn't fail under normal conditions,
        // but if rules are wrong we silently fall back to baked-in defaults.
        console.warn(`Pokemon override subscription (${format}) failed:`, err);
      }
    );
  };

  subscribe('singles');
  subscribe('doubles');
}

export function getOverride(name, format = 'doubles') {
  if (!name) return null;
  const f = format === 'singles' ? 'singles' : 'doubles';
  return cache[f]?.[name] || null;
}

export function getAllOverrides(format = 'doubles') {
  const f = format === 'singles' ? 'singles' : 'doubles';
  return cache[f] || {};
}

// React hook that re-renders when any override changes.
export function useOverridesVersion() {
  const [, tick] = useState(0);
  useEffect(() => {
    const fn = () => tick((t) => t + 1);
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  }, []);
}
